import { ChannelListFilterKey } from 'pages/Conversations/interfaces/IChannelListFilter';
import { ChannelFilterSelectionFragment } from 'shared/types/graphql';
import { ChannelListFilterSelectionDraft } from '../types/ChannelListFilterSelectionDraft';
import { ChannelListFilterDraft } from '../types/ChannelListFilterDraft';

export const convertPersistedFilterSelectionToDraft = (
  filterSelection: ChannelFilterSelectionFragment,
): ChannelListFilterSelectionDraft => {
  const filters = Object.entries(filterSelection.filters).reduce((prev, [key, value]) => {
    if (Array.isArray(value)) {
      prev[key as ChannelListFilterKey] = value.map((v) => ({ value: v, label: v }));
    } else if (key === 'unread') {
      prev.unread = [];
    } else if (typeof value === 'boolean') {
      prev[key as ChannelListFilterKey] = value;
    }
    return prev;
  }, {} as ChannelListFilterDraft);
  return { ...filterSelection, filters };
};
